import type { Translations } from './translation';

const translations: Translations = {
	ticket: 'Fahrschein',
	ticketOptions: 'Fahrscheinoptionen',
	includedInTicket: 'Im Fahrschein enthalten',
	journeyDetails: 'Verbindungsdetails',
	refreshItinerary: 'Verbindung aktualisieren',
	transfers: 'Umstiege',
	walk: 'Fußweg',
	bike: 'Fahrrad',
	cargoBike: 'Lastenfahrrad',
	scooterStanding: 'Stehroller',
	scooterSeated: 'Sitzroller',
	car: 'Auto',
	taxi: 'Taxi',
	moped: 'Moped',
	unknownVehicleType: 'Unbekannter Fahrzeugtyp',
	electricAssist: 'Elektromotorunterstützung',
	electric: 'Elektrisch',
	combustion: 'Benzin',
	combustionDiesel: 'Diesel',
	hybrid: 'Hybrid',
	plugInHybrid: 'Plug-in Hybrid',
	hydrogenFuelCell: 'Wasserstoff-Brennstoffzelle',
	from: 'Von',
	to: 'Nach',
	viaStop: 'Zwischenhalt',
	viaStops: 'Zwischenhalte',
	addViaStop: 'Zwischenhalt hinzufügen',
	removeViaStop: 'Zwischenhalt entfernen',
	viaStayDuration: 'Mindestaufenthalt',
	position: 'Position',
	arrival: 'Ankunft',
	departure: 'Abfahrt',
	duration: 'Dauer',
	arrivals: 'Ankünfte',
	connections: 'Verbindungen',
	departures: 'Abfahrten',
	later: 'später',
	earlier: 'früher',
	track: 'Gleis',
	platform: 'Steig',
	trackAbr: 'Gl.',
	platformAbr: 'Stg.',
	arrivalOnTrack: 'Ankunft auf Gleis',
	switchToArrivals: 'Wechsel zu Ankünften',
	switchToDepartures: 'Wechsel zu Abfahrten',
	tripIntermediateStops: (n: number) => {
		switch (n) {
			case 0:
				return 'Fahrt ohne Zwischenhalt';
			case 1:
				return 'Fahrt eine Station';
			default:
				return `Fahrt ${n} Stationen`;
		}
	},
	sharingProvider: 'Anbieter',
	sharingProviders: 'Anbieter',
	none: 'Keine',
	returnOnlyAtStations: 'Das Fahrzeug muss an einer Station zurückgegeben werden.',
	roundtripStationReturnConstraint:
		'Das Fahrzeug muss wieder an der Abfahrtsstation abgestellt werden.',
	rentalStation: 'Station',
	rentalGeofencingZone: 'Zone',
	noItinerariesFound: 'Keine Verbindungen gefunden.',
	advancedSearchOptions: 'Optionen',
	selectTransitModes: 'Öffentliche Verkehrsmittel auswählen',
	defaultSelectedModes: 'Alle Verkehrsmittel',
	defaultSelectedProviders: 'Alle Anbieter',
	selectElevationCosts: 'Steile Steigungen vermeiden.',
	useRoutedTransfers: 'Geroutete Umstiege verwenden',
	wheelchair: 'Nur rollstuhlgerechte Verbindungen',
	bikeRental: 'Sharing-Fahrzeuge berücksichtigen',
	requireBikeTransport: 'Fahrradmitnahme',
	requireCarTransport: 'Automitnahme',
	considerRentalReturnConstraints: 'Leihfahrzeuge innerhalb der Reise zurückgeben',
	default: 'Vorgabe',
	timetableSources: 'Fahrplandatenquellen',
	tripCancelled: 'Fahrt entfällt',
	stopCancelled: 'Halt entfällt',
	addStop: 'Haltestelle hinzufügen',
	inOutDisallowed: 'Ein-/Ausstieg nicht möglich',
	inDisallowed: 'Einstieg nicht möglich',
	outDisallowed: 'Ausstieg nicht möglich',
	unscheduledTrip: 'Zusätzliche Fahrt',
	alertsAvailable: 'Meldungen liegen vor',
	dataExpiredSince: 'Achtung: Veraltete Daten, zuletzt gültig am',
	FLEX: 'Bedarfsverkehr',
	WALK: 'Zu Fuß',
	BIKE: 'Fahrrad',
	RENTAL: 'Sharing',
	RIDE_SHARING: 'Mitfahrgelegenheit',
	CAR: 'Auto',
	CAR_DROPOFF: 'Absetzen (Auto)',
	CAR_PARKING: 'P+R Park & Ride',
	TRANSIT: 'ÖPV',
	TRAM: 'Tram',
	SUBWAY: 'U-Bahn',
	FERRY: 'Fähre',
	AIRPLANE: 'Flugzeug',
	SUBURBAN: 'S-Bahn',
	BUS: 'Bus',
	COACH: 'Reisebus',
	RAIL: 'Zug',
	HIGHSPEED_RAIL: 'Hochgeschwindigkeitszug',
	LONG_DISTANCE: 'Intercityzug',
	NIGHT_RAIL: 'Nachtzug',
	REGIONAL_FAST_RAIL: 'Schnellzug',
	ODM: 'Bedarfsverkehr',
	REGIONAL_RAIL: 'Regionalzug',
	OTHER: 'Andere',
	routingSegments: {
		maxTransfers: 'Max. Umstiege',
		maxTravelTime: 'Max. Reisezeit',
		firstMile: 'Erste Meile',
		lastMile: 'Letzte Meile',
		direct: 'Direktverbindung',
		maxPreTransitTime: 'Max. Vorlaufzeit',
		maxPostTransitTime: 'Max. Nachlaufzeit',
		maxDirectTime: 'Max. Direktzeit',
		additionalTransferTime: 'Zusätzliche Umstiegszeit',
		pedestrianSpeed: 'Fußgängergeschwindigkeit',
		cyclingSpeed: 'Fahrradgeschwindigkeit',
		transferTimeFactor: 'Umstiegszeitfaktor'
	},
	elevationCosts: { NONE: 'Keine Umwege', LOW: 'Kleine Umwege', HIGH: 'Große Umwege' },
	isochrones: {
		title: 'Isochronen',
		displayLevel: 'Darstellungsebene',
		maxComputeLevel: 'Max. Berechnungsebene',
		canvasRects: 'Rechtecke (Overlay)',
		canvasCircles: 'Kreise (Overlay)',
		geojsonCircles: 'Kreise (Geometrie)',
		styling: 'Darstellung der Isochronen',
		noData: 'Keine Daten',
		requestFailed: 'Anfrage fehlgeschlagen'
	},
	alerts: {
		validFrom: 'Gültig von',
		until: 'bis',
		information: 'Informationen',
		more: 'mehr'
	},
	RENTAL_BICYCLE: 'Bikesharing',
	RENTAL_CARGO_BICYCLE: 'Lastenrad Sharing',
	RENTAL_CAR: 'Car Sharing',
	RENTAL_MOPED: 'Moped Sharing',
	RENTAL_SCOOTER_STANDING: 'Scooter Sharing',
	RENTAL_SCOOTER_SEATED: 'Sitzroller Sharing',
	RENTAL_OTHER: 'Anderes sharing Fahrzeug',
	incline: 'Steigung',
	CABLE_CAR: 'Seilbahn',
	FUNICULAR: 'Standseilbahn',
	AERIAL_LIFT: 'Luftseilbahn',
	toll: 'Achtung! Mautpflichtige Straße.',
	accessRestriction: 'Kein Zugang',
	continuesAs: 'Weiter als',
	earlierAlternatives: 'Frühere Alternativen',
	laterAlternatives: 'Spätere Alternativen',
	differentStops: 'Andere Haltestellen',
	rent: 'Ausleihen',
	copyToClipboard: 'In die Zwischenablage kopieren',
	rideThroughAllowed: 'Durchfahrt erlaubt',
	rideThroughNotAllowed: 'Durchfahrt verboten',
	rideEndAllowed: 'Parken erlaubt',
	rideEndNotAllowed: 'Parken nur an Stationen',
	DEBUG_BUS_ROUTE: 'Busroute (Debug)',
	DEBUG_RAILWAY_ROUTE: 'Bahnroute (Debug)',
	DEBUG_FERRY_ROUTE: 'Fährenroute (Debug)',
	colorMode: {
		none: 'Nichts',
		stops: 'Haltestellen',
		rt: 'Fahrten nach Echtzeit',
		route: 'Fahrten nach Linie',
		mode: 'Fahrten nach Verkehrsmittel'
	},
	routes: (n: number) => {
		switch (n) {
			case 0:
				return 'Keine Route';
			case 1:
				return '1 Route';
			default:
				return `${n} Routen`;
		}
	}
};

export default translations;
